import { Directive, computed, inject } from '@angular/core';
import { DisclosureFacade } from '../../../facades';
import { TemplateAssertDirective } from '../template-assert.directive';

@Directive({
  standalone: true,
  selector: '[isVariableInterest]'
})
export class IsVariableInterestDirective extends TemplateAssertDirective {
  override readonly isMatch$$ = computed(() => this._disclosureFacade.isVariableInterest$$());

  private _disclosureFacade = inject(DisclosureFacade);

  constructor() {
    super();
  }
}
